module.exports = __webpack_public_path__ + "img/error-img.2cf93352.png";